<script setup>
import { ref, watch } from 'vue'
import { GoogleMap } from 'vue3-google-map'

const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
const center = { lat: 48.3016839, lng: 4.3365201 }
const mapRef = ref(null)

watch(
    () => mapRef.value?.ready,
    (ready) => {
      if (!ready) return

      try {
          const map = mapRef.value.map


      }      catch (error) {
        console.error('Error initializing Google Map:', error)
      }});
</script>

<template>
  <GoogleMap
      ref="mapRef"
      :api-key="apiKey"
      :libraries="['places','marker']"
      map-id="d6ea9d2438e17ba1812fb3c5"
      style="width: 100%; height: 500px"
      :center="center"
      :zoom="17"
  />
</template>
